export default __webpack_public_path__ + "static/media/bt.8d9397c0.svg";